<template>
  <div class="position-relative">
    <DragDrop :uppy="uppy"></DragDrop>
    <StatusBar :uppy="uppy" :props="options"></StatusBar>
  </div>
</template>

<script>
import { DragDrop, StatusBar } from "@uppy/vue";
import "@uppy/core/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import "@uppy/status-bar/dist/style.css";
import Uppy from "@uppy/core";
import German from "@uppy/locales/lib/de_DE";
import AwsS3 from "@uppy/aws-s3";
import ThumbnailGenerator from "@uppy/thumbnail-generator";

export default {
  name: "DropZone",
  components: { DragDrop, StatusBar },
  data() {
    return {
      options: {
        hideAfterFinish: false,
        showProgressDetails: true,
      },
    };
  },
  computed: {
    uppy() {
      const uppy = new Uppy({
        debug: true,
        locale: German,
        autoProceed: true,
      });
      uppy.use(ThumbnailGenerator, {
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailType: "image/png",
      });
      uppy.use(AwsS3, {
        companionUrl: "/",
      });
      uppy.on("thumbnail:generated", (file, preview) => {
        this.$emit("thumbnailCreated", { file, preview });
      });
      uppy.on("file-added", file => {
        this.$emit("fileAdded", { file });
      });
      uppy.on("upload-success", file => {
        this.$emit("uploadSuccess", { file });
      });
      return uppy;
    },
  },
};
</script>
